export const DEFAULT_NOT_SELECTED_COMPANIES = ['ДЕМО Компанія'];
